import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SidenavService } from 'src/app/sidenav/sidenav.service';
import { OverviewComponent } from './overview/overview.component';
import { Subscription } from 'rxjs';
import { LocalStorageService } from '../core/services/local-storage.service';
import { PageTitleService } from '../services/pagetitle.service';
import { WebsiteAuditService } from './website-audit.service';
import { NotificationService } from '../core/services/notification.service';
import { ManagementComponent } from './management/management.component';
import { DiagnosticComponent } from './diagnostic/diagnostic.component';
import { TechnicalComponent } from './technical/technical.component';
// import { SeoComponent } from './seo/seo.component';
// import { GeoComponent } from './geo/geo.component';
import { SeoService } from '../seo/seo.service';
import { SelectionService } from '../services/selection.service';
// import { AgenticEcommerceComponent } from './agentic-ecommerce/agentic-ecommerce.component';
import { ExperienceComponent } from './experience/experience.component';
import { DiscoverabilityComponent } from './discoverability/discoverability.component';
import { TechnicalFoundationsComponent } from './technical-foundations/technical-foundations.component';
import { BehavioralScienceComponent } from './behavioral-science/behavioral-science.component';
import { OpportunitiesComponent } from './opportunities/opportunities.component';

@Component({
  selector: 'app-website-audit',
  templateUrl: './website-audit.component.html',
})
export class WebsiteAuditComponent implements OnInit {
  constructor(
    public router: Router,
    private route: ActivatedRoute,
    private sidenavService: SidenavService,
    private localStorageService: LocalStorageService,
    private pageTitle: PageTitleService,
    private websiteAuditService: WebsiteAuditService,
    private notificationService: NotificationService,
    private seoService: SeoService,
    private selectorService: SelectionService,
  ) {}

  private subs = new Subscription();

  public selectedTab = 0;
  public tabs = [
    {
      label: 'Overview',
      role: 'websiteAudit',
      component: OverviewComponent,
      disabled: false,
    },
    {
      label: 'Opportunities',
      role: 'websiteAudit',
      component: OpportunitiesComponent,
      disabled: false,
    },
    {
      label: 'Experience',
      role: 'websiteAudit',
      component: ExperienceComponent,
      disabled: false,
    },
    {
      label: 'Discoverability',
      role: 'websiteAudit',
      component: DiscoverabilityComponent,
      disabled: false,
    },
    {
      label: 'Technical Foundations',
      role: 'websiteAudit',
      component: TechnicalFoundationsComponent,
      disabled: false,
    },
    {
      label: 'Behavioral Science',
      role: 'websiteAudit',
      component: BehavioralScienceComponent,
      disabled: false,
    },
    {
      label: 'Audits',
      role: 'websiteAudit',
      component: ManagementComponent,
      disabled: false,
      dontShowOnShare: true,
    },
  ];

  taskId: string = '';
  selectedAuditTask: any = null;
  isShareableComponent: boolean = false;
  token: string = '';

  private selectedTaskResponse: any;

  private timeout: any;
  private timeoutSeconds: number = 20;

  private timeoutTasks: any;

  ngOnInit(): void {
    this.pageTitle.setTitle('Website Audit');

    if (this.router.url.includes('/share/website-audit')) {
      this.isShareableComponent = true;
    }

    const capitalizeFirstLetter = (str: any) => {
      try {
        return str.charAt(0).toUpperCase() + str.slice(1);
      } catch (e) {
        return str;
      }
    };

    this.subs.add(
      this.sidenavService.getActiveTabIndex().subscribe((index: any) => {
        const isDisabled = this.tabs[index]?.disabled;
        if (isDisabled) {
          this.selectedTab = this.tabs.findIndex((tab) => !tab.disabled);
        } else {
          this.selectedTab = index;
        }
      }),
    );

    const OverviewTab: any = this.tabs.find((t: any) => t.label == 'Overview');
    // const UXTab: any = this.tabs.find((t: any) => t.label == 'UX');
    // const CRTab: any = this.tabs.find((t: any) => t.label == 'CR');
    // const TechTab: any = this.tabs.find((t: any) => t.label == 'Technical');
    // const DiagTab: any = this.tabs.find((t: any) => t.label == 'Diagnostic');
    // const SEOCard: any = this.tabs.find((t: any) => t.label == 'SEO');
    // const GEOCard: any = this.tabs.find((t: any) => t.label == 'GEO');
    const experienceTab: any = this.tabs.find(
      (t: any) => t.label == 'Experience',
    );
    const discoverabilityTab: any = this.tabs.find(
      (t: any) => t.label == 'Discoverability',
    );
    const techFoundationsTab: any = this.tabs.find(
      (t: any) => t.label == 'Technical Foundations',
    );
    const behavioralTab: any = this.tabs.find(
      (t: any) => t.label == 'Behavioral Science',
    );
    const opportunitiesTab: any = this.tabs.find(
      (t: any) => t.label == 'Opportunities',
    );

    let uxDisabled = false;
    let crDisabled = false;
    let seoDisabled = false;
    let geoDisabled = false;
    let techDisabled = false;
    let diagDisabled = false;

    if (this.isShareableComponent) {
      this.tabs = this.tabs.filter((tab) => !tab.dontShowOnShare);

      this.token = this.route.snapshot.paramMap.get('token') as string;

      sessionStorage.setItem('shareable-website-audit-auth', this.token);

      this.subs.add(
        this.websiteAuditService.getAuditTaskFromToken(this.token).subscribe({
          next: (res: any) => {
            if (res) {
              res['domain'] = this.getDomainFromUrl(res?.url);
              res['formatted_domain'] = capitalizeFirstLetter(
                this.getDomainFromUrl(res?.url)?.split('.')[0],
              );

              if (typeof res?.target === 'string' && res.target) {
                sessionStorage.setItem('target', res.target);
              }

              // The shared-task response can omit `type` (like the single-task
              // detail), and the public page has no audit list to backfill from.
              // Recover it from the share link: an explicit `type`, or the
              // `crawl_`-prefixed taskId that Agentic Ecommerce audits always
              // carry — so a Crawler audit hides Overview and defaults to the
              // Agentic tab here too.
              if (!res.type) {
                const qp = new URLSearchParams(window.location.search);
                const sharedType = qp.get('type');
                const taskId =
                  qp.get('taskId') || res?.taskId || res?.parentTaskId || '';
                if (sharedType) {
                  res.type = sharedType;
                } else if (String(taskId).startsWith('crawl_')) {
                  res.type = 'Crawler';
                }
              }

              if (res?.type === 'Crawler') {
                // Keep the tab order consistent with the dashboard: disable
                // Overview + the full-audit tabs and default to Agentic Ecommerce
                // in its usual place (after Diagnostic), instead of hoisting it
                // to the front in Overview's slot.
                this.applyCrawlerTabs();
                this.websiteAuditService.updateSelectedAuditTask(res);
                return;
              }

              // New API exposes section status under overview.status.target;
              // fall back to the legacy flat progress fields for older payloads.
              const statusTarget = res?.overview?.status?.target;

              if (statusTarget) {
                // UXTab['disabled'] = !this.isSectionDone(statusTarget.ux);
                // CRTab['disabled'] = !this.isSectionDone(statusTarget.cr);
                // TechTab['disabled'] = !this.isSectionDone(
                //   statusTarget.technical,
                // );
                // DiagTab['disabled'] = !this.isSectionDone(
                //   statusTarget.diagnostic,
                // );
                uxDisabled = !this.isSectionDone(statusTarget.ux);
                crDisabled = !this.isSectionDone(statusTarget.cr);
                techDisabled = !this.isSectionDone(statusTarget.technical);
                diagDisabled = !this.isSectionDone(statusTarget.diagnostic);
              } else {
                // UXTab['disabled'] =
                //   res?.uxProgress < 100 || res?.crStatus == 'failed';
                // CRTab['disabled'] =
                //   res?.uxProgress < 100 || res?.crStatus == 'failed';
                // TechTab['disabled'] =
                //   res?.insightProgress < 100 ||
                //   res?.technicalStatus == 'failed';
                // DiagTab['disabled'] =
                //   res?.errorProgress < 100 || res?.errorStatus == 'failed';
                uxDisabled = res?.uxProgress < 100 || res?.crStatus == 'failed';
                crDisabled = res?.uxProgress < 100 || res?.crStatus == 'failed';
                techDisabled =
                  res?.insightProgress < 100 ||
                  res?.technicalStatus == 'failed';
                diagDisabled =
                  res?.errorProgress < 100 || res?.errorStatus == 'failed';
              }

              experienceTab['disabled'] = uxDisabled && crDisabled;
              techFoundationsTab['disabled'] = techDisabled && diagDisabled;
              behavioralTab['disabled'] = !this.isBehavioralReady(res);
              opportunitiesTab['disabled'] = !this.hasOpportunities(res);

              this.subs.add(
                this.websiteAuditService
                  .getAuditGeneral({
                    domain: res['domain'],
                  })
                  .subscribe({
                    next: (data: any) => {
                      res['website_name'] = data?.general_obj?.website_name;
                      this.websiteAuditService.updateSelectedAuditTask(res);

                      // SEOCard['disabled'] = false;
                      // GEOCard['disabled'] = false;
                      seoDisabled = false;
                      geoDisabled = false;

                      discoverabilityTab['disabled'] =
                        seoDisabled && geoDisabled;
                    },
                    error: (err: any) => {
                      this.websiteAuditService.updateSelectedAuditTask(res);
                      // SEOCard['disabled'] = true;
                      // GEOCard['disabled'] = true;
                      seoDisabled = true;
                      geoDisabled = true;

                      discoverabilityTab['disabled'] =
                        seoDisabled && geoDisabled;
                    },
                  }),
              );
            }
          },
          error: (err: any) => {
            this.notificationService.error(err?.error?.message);
          },
        }),
      );
      return;
    }

    const params = new URLSearchParams(window.location.search);

    params.forEach((value, key) => {
      if (key === 'taskId') {
        this.taskId = value;
      }
    });

    // target change
    this.subs.add(
      this.selectorService.currentMessage.subscribe((message) => {
        this.selectedTaskResponse = null;
        this.selectedAuditTask = null;
        this.websiteAuditService.fetchAuditTasks();
      }),
    );

    // tasks list
    this.subs.add(
      this.websiteAuditService.getAuditTasks().subscribe((tasks) => {
        const isEveryTaskFailed = tasks?.every(
          (t: any) => t.status === 'Failed',
        );

        if (tasks?.length > 0 && !isEveryTaskFailed) {
          const areThereTasksInProgress = tasks.some(
            (task: any) => task.progress < 100,
          );

          if (this.timeoutTasks) {
            clearTimeout(this.timeoutTasks);
            this.timeoutTasks = null;
          }
          if (areThereTasksInProgress) {
            this.timeoutTasks = setTimeout(() => {
              this.websiteAuditService.fetchAuditTasks();
            }, this.timeoutSeconds * 1000);
          }

          if (
            !this.selectedTaskResponse ||
            this.selectedTaskResponse?.progress < 100 ||
            !this.sameAudit(this.selectedTaskResponse, this.selectedAuditTask)
          ) {
            if (this.taskId) {
              // The list keys audits by the parent/canonical taskId, but the
              // single-task detail returns the latest run's taskId. Match on
              // either (taskId or parentTaskId) so re-runs don't "lose" the
              // selected audit.
              this.selectedAuditTask =
                this.findAuditInList(tasks, [
                  this.taskId,
                  this.selectedTaskResponse?.taskId,
                  this.selectedTaskResponse?.parentTaskId,
                ]) || null;
            } else {
              let task = this.findTaskFromStatus(tasks, 'done');
              const firstTask = tasks?.[0] || null;

              // if done doesn't exists get one that is running
              if (!task) {
                task = this.findTaskFromStatus(tasks, 'running');
              }

              // get the first one if its not failed
              if (!task && firstTask?.status != 'Failed') {
                task = firstTask;
              }

              this.selectedAuditTask = task;
            }

            if (!this.selectedAuditTask) {
              this.selectedAuditTask =
                tasks?.find(
                  (task: any) => task?.status?.toLowerCase() === 'done',
                ) ||
                tasks?.[0] ||
                null;
            }

            // Configure tabs from the known list type right away, so an
            // Agentic Ecommerce audit never briefly shows Overview while its
            // detail (which also disables the tab) is still loading.
            if (this.selectedAuditTask?.type === 'Crawler') {
              this.applyCrawlerTabs();
            }

            this.router.navigate([], {
              queryParams: {
                taskId:
                  this.selectedTaskResponse?.parentTaskId ||
                  this.selectedTaskResponse?.taskId ||
                  this.selectedAuditTask?.parentTaskId ||
                  this.selectedAuditTask?.taskId,
              },
              queryParamsHandling: 'merge',
              replaceUrl: true,
            });

            this.getAuditTask();
          }
        } else {
          this.selectedAuditTask = null;
          this.tabs.forEach((tab: any) => {
            if (
              tab.label != 'Overview' &&
              tab.label != 'Audits' &&
              tab.label != 'Agentic Ecommerce'
            ) {
              tab.disabled = true;
            }
          });
          this.websiteAuditService.updateSelectedAuditTask(null);
        }
      }),
    );

    // selected task
    this.subs.add(
      this.websiteAuditService.getSelectedAuditTask().subscribe((res: any) => {
        if (res) {
          if (this.selectedTaskResponse?.taskId != res?.taskId) {
            setTimeout(() => {
              this.getAuditTask();
            }, 50);
          }
          this.selectedTaskResponse = res;
          this.taskId = res?.taskId || this.taskId;

          if (this.selectedTaskResponse?.type === 'Crawler') {
            this.applyCrawlerTabs();
            return;
          }
          OverviewTab['disabled'] = false;

          const statusTarget = res?.overview?.status?.target;
          if (statusTarget) {
            // UXTab['disabled'] = !this.isSectionDone(statusTarget.ux);
            // CRTab['disabled'] = !this.isSectionDone(statusTarget.cr);
            // TechTab['disabled'] = !this.isSectionDone(statusTarget.technical);
            // DiagTab['disabled'] = !this.isSectionDone(statusTarget.diagnostic);
            uxDisabled = !this.isSectionDone(statusTarget.ux);
            crDisabled = !this.isSectionDone(statusTarget.cr);
            techDisabled = !this.isSectionDone(statusTarget.technical);
            diagDisabled = !this.isSectionDone(statusTarget.diagnostic);
          } else {
            // UXTab['disabled'] =
            //   res?.uxProgress < 100 || res?.crStatus == 'failed';
            // CRTab['disabled'] =
            //   res?.uxProgress < 100 || res?.crStatus == 'failed';
            // TechTab['disabled'] =
            //   res?.insightProgress < 100 || res?.technicalStatus == 'failed';
            // DiagTab['disabled'] =
            //   res?.errorProgress < 100 || res?.errorStatus == 'failed';
            uxDisabled = res?.uxProgress < 100 || res?.crStatus == 'failed';
            crDisabled = res?.uxProgress < 100 || res?.crStatus == 'failed';
            techDisabled =
              res?.insightProgress < 100 || res?.technicalStatus == 'failed';
            diagDisabled =
              res?.errorProgress < 100 || res?.errorStatus == 'failed';
          }

          experienceTab['disabled'] = uxDisabled && crDisabled;
          techFoundationsTab['disabled'] = techDisabled && diagDisabled;
          behavioralTab['disabled'] = !this.isBehavioralReady(res);
          opportunitiesTab['disabled'] = !this.hasOpportunities(res);

          const crawlStatus = res?.organicProgress?.status;
          const averageStatusBar = res?.organicProgress?.progress;

          if (averageStatusBar >= 100 && crawlStatus != 'failed') {
            // SEOCard['disabled'] = false;
            // GEOCard['disabled'] = false;
            seoDisabled = false;
            geoDisabled = false;
          } else {
            seoDisabled = true;
            geoDisabled = true;
          }

          discoverabilityTab['disabled'] = seoDisabled && geoDisabled;

          if (this.tabs[this.selectedTab].disabled) {
            this.selectedTab = 0;
            this.sidenavService.updateActiveTabIndex(this.selectedTab);
          }
        }
      }),
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();

    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }

    if (this.timeoutTasks) {
      clearTimeout(this.timeoutTasks);
      this.timeoutTasks = null;
    }
  }

  private findTaskFromStatus(tasks: any, status: string) {
    return (
      tasks.find((task: any) => task?.status?.toLowerCase() === status) || null
    );
  }

  // A one-time/biweekly audit is identified by its parent taskId, while each
  // run has its own taskId. The list shows the parent (canonical) task and the
  // detail endpoint returns the latest run, so selection must reconcile both.
  private auditIds(t: any): string[] {
    if (!t) return [];
    return [t.taskId, t.parentTaskId].filter(Boolean);
  }

  private sameAudit(a: any, b: any): boolean {
    const idsA = this.auditIds(a);
    const idsB = this.auditIds(b);
    return (
      idsA.length > 0 && idsB.length > 0 && idsA.some((id) => idsB.includes(id))
    );
  }

  private findAuditInList(tasks: any[], ids: (string | undefined)[]): any {
    const wanted = (ids || []).filter(Boolean) as string[];
    if (!wanted.length) return null;
    return (
      (tasks || []).find((t: any) =>
        this.auditIds(t).some((id) => wanted.includes(id)),
      ) || null
    );
  }

  private isSectionDone(status: any): boolean {
    return (status || '').toString().toLowerCase() === 'done';
  }

  // Behavioral Science is an optional section (older audits and Crawler runs
  // don't carry it), so gate its tab on the section's own status and fall back
  // to the overview status map for payloads that only expose that.
  private isBehavioralReady(res: any): boolean {
    const status =
      res?.sections?.behavioralScience?.status ??
      res?.overview?.status?.target?.behavioralScience;
    return this.isSectionDone(status);
  }

  // Opportunities is a roll-up of the other sections and carries no status of
  // its own, so the tab follows whether the section has any rows to show.
  private hasOpportunities(res: any): boolean {
    const items = res?.sections?.opportunities?.items;
    return Array.isArray(items) && items.length > 0;
  }

  // Agentic Ecommerce (Crawler) audits have no full-audit report — the only
  // thing they produce is AI Shopping Readiness, which now lives as a chip
  // inside Discoverability. So Discoverability is the only enabled report tab
  // (its component hides the SEO/GEO chips for a crawler) and every other
  // report tab is grayed, like UX/CR on an unfinished audit. Audits stays
  // enabled so the audit list is still reachable. Kept in one place so it can
  // run eagerly from the list type and again once the detail resolves — no
  // window where a disabled tab is the active one for a crawler.
  private applyCrawlerTabs(): void {
    const enabled = ['Discoverability', 'Audits'];
    this.tabs.forEach((tab: any) => {
      tab.disabled = !enabled.includes(tab.label);
    });

    const discoverabilityIndex = this.tabs.findIndex(
      (t: any) => t.label === 'Discoverability',
    );
    // Switch only when the current tab isn't usable for a crawler audit (i.e.
    // it just got disabled). Staying put on an enabled tab like Audits is fine.
    const current = this.tabs[this.selectedTab];
    if (discoverabilityIndex > -1 && (!current || current.disabled)) {
      this.selectedTab = discoverabilityIndex;
      this.sidenavService.updateActiveTabIndex(this.selectedTab);
    }
  }

  // The single-task endpoint now returns a nested shape:
  // { target, selectedCompetitor, availableCompetitors, overview, sections }
  // Flatten `target` to the top level (so taskId/url/status keep working) and
  // attach the new blocks for the redesigned Overview to consume.
  private normalizeAuditResponse(res: any): any {
    if (res && res.target && typeof res.target === 'object') {
      return {
        ...res.target,
        overview: res.overview || null,
        sections: res.sections || null,
        selectedCompetitor: res.selectedCompetitor || null,
        availableCompetitors: res.availableCompetitors || [],
      };
    }
    return res;
  }

  getAuditTask() {
    if (!this.selectedAuditTask) {
      return;
    }

    const taskId =
      this.selectedTaskResponse?.taskId || this.selectedAuditTask?.taskId;

    this.subs.add(
      this.websiteAuditService.getAuditTask(taskId).subscribe({
        next: (res) => {
          const normalized = this.normalizeAuditResponse(res);

          this.websiteAuditService.updateSelectedAuditTask({
            ...this.selectedTaskResponse,
            ...normalized,
          });

          if (
            !this.selectedTaskResponse?.organicProgress ||
            this.selectedTaskResponse?.organicProgress?.progress < 100
          ) {
            this.getStatusOfProject(normalized);
          }
        },
        error: (err) => {
          this.websiteAuditService.updateSelectedAuditTask(null);
          this.notificationService.error(err?.error?.message);
        },
      }),
    );
  }

  getDomainFromUrl(url: string): string | null {
    try {
      const normalized = url.startsWith('http') ? url : `https://${url}`;

      const { hostname } = new URL(normalized);
      return hostname.replace(/^www\./, '');
    } catch {
      return null;
    }
  }

  getStatusOfProject(res: any) {
    if (!res) return;

    const domainFromUrl = this.getDomainFromUrl(res?.url);

    this.seoService.getStatusOfProject({ domain: domainFromUrl }).subscribe({
      next: (res: any) => {
        const crawlStatus = res?.progresses?.[0]?.crawl_status || '';

        this.websiteAuditService.updateSelectedAuditTask({
          ...this.selectedTaskResponse,
          organicProgress: {
            progress: res?.averageStatusBar,
            status: crawlStatus,
          },
        });
      },
      error: (err) => {
        this.websiteAuditService.updateSelectedAuditTask({
          ...this.selectedTaskResponse,
          organicProgress: {
            progress: 0,
            status: 'failed',
          },
        });
      },
    });
  }

  private _animationRunning = false;
  get animationRunning() {
    return this._animationRunning;
  }
  indexChange() {
    this._animationRunning = true;
  }
  onAnimationDone() {
    this.sidenavService.updateActiveTabIndex(this.selectedTab);
    this._animationRunning = false;
    this.sidenavService.triggerPageChange();
  }

  checkRoleGuard(page: any) {
    const role: string[] = this.localStorageService.get('privileges') || [];
    if (role.length > 0) {
      if (role.findIndex((priv) => priv == page) < 0) {
        return false;
      } else {
        return true;
      }
    } else {
      this.router.navigate(['login']);
      return false;
    }
  }
}
